<template>
  <v-container fluid>
    <Good
      v-model="editGoodItem"
      :save-callback="onSaveGood"
      :read-only="!canAddAndEdit"
    />

    <v-row dense>
      <v-col
        v-if="!this.$store.state.auth.user.cargoTypeID"
        cols="3"
      >
        <CargoTypeSelector
          v-model="cargoTypeID"
          dense
          :can-any="true"
          @input="onFilterChanged"
        />
      </v-col>

      <v-col>
        <v-text-field
          v-model="articleContains"
          dense
          append-icon="mdi-magnify"
          label="Артикул содержит"
          single-line
          hide-details
          autocomplete="off"
          class="pb-4"
          @input="lazyQuery(onFilterChanged)"
        />
      </v-col>

      <v-col>
        <v-text-field
          v-model="nameContains"
          dense
          append-icon="mdi-magnify"
          label="Наименование содержит"
          single-line
          hide-details
          autocomplete="off"
          class="pb-4"
          @input="lazyQuery(onFilterChanged)"
        />
      </v-col>
    </v-row>

    <v-data-table
      dense
      :items="items"
      :headers="headers"
      :loading="loading"
      :server-items-length="rows"
      :expanded="expanded"
      show-expand
      hide-default-footer
      disable-pagination
      disable-filtering
      disable-sort
      item-key="id"
      loading-text="Загрузка данных..."
      no-data-text="Нет данных, соответствующих фильтру..."
      no-results-text="Совпадений не найдено..."
      class="styled-table pointed-table"
      @click:row="toggleExpanded"
    >
      <!-- expand column -->
      <template v-slot:[`item.data-table-expand`]="{isExpanded, expand, item}">
        <v-icon
          v-if="!isExpanded && item.rests.length"
          @click="expand(true)"
        >
          mdi-chevron-down
        </v-icon>
        <v-icon
          v-if="isExpanded && item.rests.length"
          @click="expand(false)"
        >
          mdi-chevron-up
        </v-icon>
      </template>

      <template v-slot:expanded-item="{headers, item}">
        <td
          v-if="item.rests.length"
          :colspan="headers.length"
          class="px-0"
        >
          <!-- подтаблица -->
          <v-data-table
            :items="item.rests"
            :headers="restsHeaders(item.cargoTypeID)"
            item-key="id"
            dense
            hide-default-footer
            disable-filtering
            disable-pagination
            disable-sort
          >
            <template v-slot:[`item.restPackage`]="props">
              {{ Math.ceil(props.item.qty / item.qiPackage) }}
            </template>

            <template v-slot:[`item.productionDate`]="props">
              {{ props.item.productionDate | dateFormat }}
            </template>
          </v-data-table>
        </td>
      </template>

      <template v-slot:[`item.restPallet`]="{ item }">
        {{ item.rests.reduce((acc, c)=>acc+c.qtyPallet, 0) }}
      </template>
      <template v-slot:[`item.restPackage`]="{ item }">
        {{ item.rests.reduce((acc, c)=>acc+c.qty, 0)/item.qiPackage }}
      </template>

      <!-- actions -->
      <template v-slot:[`item.actions`]="{item}">
        <div class="d-flex justify-space-between">
          <v-tooltip
            v-if="canAddAndEdit"
            bottom
          >
            <template v-slot:activator="{on, attrs}">
              <v-icon
                v-bind="attrs"
                color="primary"
                v-on="on"
                @click.stop="editClick(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Изменить</span>
          </v-tooltip>

          <v-tooltip
            v-if="canDelete(item)"
            bottom
          >
            <template v-slot:activator="{on, attrs}">
              <v-icon
                v-bind="attrs"
                color="red"
                v-on="on"
                @click.stop="deleteClick(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>

    <!-- кнопка добавить -->
    <v-btn
      v-if="canAddAndEdit"
      bottom
      right
      color="primary"
      dark
      fab
      fixed
      :loading="loading"
      @click.prevent="addClick()"
    >
      <v-icon class="white--text">
        mdi-plus
      </v-icon>
    </v-btn>

    <v-pagination
      v-if="pageCount && pageCount > 1"
      v-model="page"
      :length="pageCount"
      total-visible="6"
      class="tableHeader"
      @input="onPageChanged"
    />

    <RowsSelector
      v-model="rows"
      @input="onRowsChanged"
    />
  </v-container>
</template>

<script>
import CargoTypeSelector from "@/components/CargoTypeSelector"
import RowsSelector from "@/components/RowsSelector"
import Good from "@/views/GoodsDirectory/Good"
import saveState from "@/utils/saveState"
import lazyQuery from "@/utils/lazyQuery"

// TODO: по-хорошему должно быть удаление позиции, но если по ней нет оборота, иначе будут удалять лишнее...
// TODO: надо добавить остатки, причём суммарные, и по детализации как-то показывать какой партии/срока годности сколько лежит
export default {
  components: {
    RowsSelector,
    CargoTypeSelector,
    Good
  },

  mixins: [saveState, lazyQuery],
  data: () => ({
    // диалог с товаром
    editGoodItem: null,

    loading: false,
    mounted: false,
    // пагинация
    page: 1,
    pageCount: 1,
    rows: 1,
    // фильтр
    cargoTypeID: 0,
    articleContains: "",
    nameContains: "",
    // элементы
    items: [],
    expanded: [],

    headers: [
      {
        text: "",
        value: "data-table-expand",
        width: "56px",
        class: "tableHeader tableHeaderText--text",
        sortable: false
      },
      { text: "Артикул", value: "article", class: "tableHeader tableHeaderText--text" },
      { text: "Наименование", value: "name", class: "tableHeader tableHeaderText--text" },
      { text: "В уп.", align: "center", value: "qiPackage", class: "tableHeader tableHeaderText--text" },
      { text: "На поддоне", align: "center", value: "qiPallet", class: "tableHeader tableHeaderText--text" },
      { text: "Цена упаковки", align: "center", value: "price", class: "tableHeader tableHeaderText--text" },
      { text: "Вес шт, кг", align: "center", value: "weight", class: "tableHeader tableHeaderText--text" },
      {
        text: "На складе, упаковок",
        align: "center",
        value: "restPackage",
        class: "tableHeader tableHeaderText--text"
      },
      { text: "На складе, поддонов", align: "center", value: "restPallet", class: "tableHeader tableHeaderText--text" }
    ]
  }),

  computed: {
    canAddAndEdit() {
      return this.$store.state.auth.user.role === "Клиент" || this.$store.state.auth.user.role === "Администратор"
    }
  },

  created() {
    document.addEventListener("keydown", this.keydown)

    // столбец с типом груза только для тех, кто видит разные
    if (!this.$store.state.auth.user.cargoTypeID) {
      this.headers.splice(0, 0, {
        text: "Тип груза",
        value: "cargoType.name",
        class: "tableHeader tableHeaderText--text"
      })
    }

    // столбец с действиями только для тех, кто может
    if (this.canAddAndEdit) {
      this.headers.push({
        text: "",
        value: "actions",
        sortable: false,
        width: "72px",
        class: "tableHeader tableHeaderText--text",
        align: "center"
      })
    }
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.keydown)
  },

  mounted() {
    this.mounted = true
    this.getPageCount().then(() => this.getItems())
  },

  methods: {
    saveStateConfig() {
      return {
        saveKey: "goods",
        saveProperties: ["cargoTypeID", "articleContains", "nameContains", "page"]
      }
    },

    // количество страниц данных для пагинации
    getPageCount() {
      return this.axios
        .get("/goods/getPageCount", {
          params: {
            rowsPerPage: this.rows,
            // filter:
            cargoTypeID: this.cargoTypeID,
            articleContains: this.articleContains,
            nameContains: this.nameContains
          }
        })
        .then((response) => {
          this.pageCount = response.data
        })
        .catch((err) => {
          this.$router.push(`/error?message=Ошибка при получении количества страниц товаров&&error=${err}`)
        })
    },

    // получение данных
    async getItems() {
      this.loading = true
      // this.items = []
      if (this.page > this.pageCount && this.page !== 1) this.page = this.pageCount
      await this.axios
        .get("/goods/get", {
          params: {
            page: this.page,
            rowsPerPage: this.rows,
            // filter:
            cargoTypeID: this.cargoTypeID,
            articleContains: this.articleContains,
            nameContains: this.nameContains
          }
        })
        .then((response) => {
          this.items = response.data
          this.loading = false
        })
        .catch((err) => {
          this.$router.push(`/error?message=Ошибка при получении списка товаров&&error=${err}`)
        })
    },

    onFilterChanged() {
      this.page = 1
      this.getPageCount().then(() => this.getItems())
    },

    onPageChanged() {
      this.getItems()
    },

    onRowsChanged() {
      if (!this.mounted) return
      this.page = 1
      this.getPageCount().then(() => this.getItems())
    },

    restsHeaders(cargoTypeID) {
      const usePartNumber = this.$store.getters["cargoTypes/getItemByID"](cargoTypeID).usePartNumber
      return [
        { text: "", align: "center", value: "empty" },
        usePartNumber
          ? { text: "Партия", align: "center", value: "partNumber", width: "130px" }
          : { text: "Дата производства", align: "center", value: "productionDate", width: "130px" },
        { text: "Штук", align: "center", value: "qty", width: "80px" },
        { text: "Упаковок", align: "center", value: "restPackage", width: "80px" },
        { text: "Поддонов", align: "center", value: "qtyPallet", width: "80px" }
      ]
    },

    toggleExpanded(value) {
      if (!value.rests.length) return
      const x = this.expanded.pop()
      if (x !== value) {
        this.expanded.push(value)
      }
    },

    canDelete(item) {
      return (
        !item.rests.length &&
        (this.$store.state.auth.user.role === "Клиент" || this.$store.state.auth.user.role === "Администратор")
      )
    },

    // удалить
    async deleteClick(item) {
      if (
        !(await this.$messageBox(
          `Удалить товар <span class="accent--text">${item.name}</span>(Артикул <span class="accent--text">${item.article}</span>)?`
        ))
      ) {
        return
      }

      try {
        this.loading = true
        await this.axios.delete(`/goods/delete/${item.id}`)
        this.items.splice(this.items.indexOf(item), 1)
        this.$notify("success", "Товар удалён")
      } catch (err) {
        this.$notify("error", err.response?.data?.message ? err.response.data.message : "Ошибка при удалении товара")
      } finally {
        this.loading = false
        this.dialog = false
      }
    },

    deleteItem(itemID) {
      const index = this.items.findIndex((el) => el.id === itemID)
      if (index !== -1) this.items.splice(index, 1)
    },

    // открыть диалог добавления
    addClick() {
      this.editGoodItem = {}
      // здесь косяк с "центром", так как у них значения нет и надо выбирать из списка каждый раз
      // поэтому пихаем туда из фильтра значение, если он выбран
      if (this.cargoTypeID !== 0) {
        this.editGoodItem.cargoTypeID = this.cargoTypeID
      }
    },

    /// //////// РЕДАКТИРОВАНИЕ //////// ///
    keydown(value) {
      if (value.code === "NumpadAdd" && this.canAddAndEdit) {
        this.addClick()
      }
    },

    // редактирование
    editClick(value) {
      this.editGoodItem = value
    },

    // сохранение
    async onSaveGood(good) {
      return good.id < 0 ? await this.insertGood(good) : await this.updateGood(good)
    },

    async updateGood(good) {
      return this.axios
        .put("/goods/update", { ...good })
        .then(() => {
          this.onFilterChanged()
          return true
        })
        .catch((err) => {
          this.$notify("error", err.response?.data?.message ? err.response.data.message : "Ошибка при изменении товара")
          return false
        })
    },

    async insertGood(good) {
      return this.axios
        .post("/goods/insert", { ...good })
        .then(() => {
          this.onFilterChanged()
          return true
        })
        .catch((err) => {
          this.$notify("error", err.response?.data?.message ? err.response.data.message : "Ошибка при создании товара")
          return false
        })
    }
    /// //////// РЕДАКТИРОВАНИЕ //////// ///
  }
}
</script>
